import BreadcrumbLink from 'features/shared/components/breadcrumbs/BreadcrumbLink';
import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React, { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import NavTab from 'features/shared/components/navs/NavTab';
import TabsNavigation from 'features/shared/components/navs/TabsNavigation';
import { loadPortalConfig } from 'features/shared/helpers/modules';

const portalConfig = loadPortalConfig();

type Props = {
  children: ReactNode;
  links: BreadcrumbLink[];
  showLinkToDetail?: boolean;
}

const FuelingContractDetailLayoutPage = ({ children, links, showLinkToDetail = true }: Props) => {
  // translation
  const tModules = useTranslation("shared\\moduleNames").t;
  const tLabels = useTranslation("contracts\\contracts").t;

  // helpers
  const getLinks = (): BreadcrumbLink[] => {
    let result: BreadcrumbLink[] = [getRootLink()];  

    if (showLinkToDetail) {
      result.push({ text: tModules("contractDetail.title"), to: `detail` });
    }

    result.push(...links);

    return result;
  }

  const getRootLink = (): BreadcrumbLink => {
    if (portalConfig.useContractualAccounts) {
      return { text: tModules("contractualAccounts.title"), to: "/contractual-accounts" };
    } else {
      return { text: tModules("fuelingContracts.title"), to: "/fueling-contracts" };
    }
  }

  // render
  return (
    <>
      <Header
        title={tModules("fuelingContractDetail.title")}
        includeBreadcrumbs
        titleAsBreadcrumbLink={false}
        links={getLinks()}
      />
      <ModuleContent>
        <TabsNavigation asModuleTabs>
          <NavTab to={`detail`}>
            <span className="d-sm-none"> {tLabels("fuelingContractDetailLayoutPage.contractDetail.mobile")}</span> 
            <span className="d-none d-sm-inline"> {tLabels("fuelingContractDetailLayoutPage.contractDetail.desktop")}</span> 
          </NavTab>
          <NavTab to="history">
            {tLabels("fuelingContractDetailLayoutPage.fuelingHistory.desktop")}
          </NavTab>
        </TabsNavigation>
        {children}
      </ModuleContent>
    </>
  );
}

export default FuelingContractDetailLayoutPage;